const { formatImage, formatUrl } = require('@ifeng-fe/public_method');
const { homeFeedFormatData } = require('./utils');

const handleChildrenData = data => {
    try {
        if (data) {
            return data.map(item => ({
                base62Id: item.base62Id || item.base62,
                url: item.url,
                title: item.title,
                pcNewsMark: item.pcNewsMark,
            }));
        }
    } catch (error) {
        console.error(error);
    }

    return null;
};

const homeModuleTitleFormatData = data => {
    try {
        const subTitArr =
            data.subList &&
            data.subList.map(item => ({
                title: item.title || '',
                url: item.url || '',
            }));
        const mdInfo = {
            moduleTh: {
                title: data.title || '',
                url: data.url || '',
                subTit: subTitArr,
            },
            moreTh: {
                title: data.moreTitle || '',
                link: data.moreUrl || '',
            },
        };

        return mdInfo;
    } catch (error) {
        console.error(error);
    }

    return data;
};

const homeModuleBannerFormatData = data => {
    try {
        const bannerData =
            data &&
            data.map(item => ({
                id: item.id || '',
                title: item.title || '',
                link: item.url || '',
                type: item.type || '',
                url: item.url || '',
                image:
                    (item.thumbnail && formatImage(item.thumbnail, 750, 376)) ||
                    (item.thumbnails &&
                        item.thumbnails.image &&
                        item.thumbnails.image[0] &&
                        item.thumbnails.image[0].url &&
                        formatImage(item.thumbnails.image[0].url, 750, 376)) ||
                    (item.posterUrl && formatImage(item.posterUrl, 750, 376)) ||
                    '',
            }));

        return bannerData;
    } catch (error) {
        console.error(error);
    }

    return data;
};

const homeModuleSlideFormatData = data => {
    try {
        const slideData =
            data &&
            data.map(item => ({
                id: item.id || '',
                title: item.title || '',
                link: item.url || '',
                type: item.type || 'phvideo',
                url: item.url || '',
                src:
                    (item.thumbnail && formatImage(item.thumbnail, 698, 350)) ||
                    (item.thumbnails &&
                        item.thumbnails.image &&
                        item.thumbnails.image[0] &&
                        item.thumbnails.image[0].url &&
                        formatImage(item.thumbnails.image[0].url, 698, 350)) ||
                    (item.posterUrl && formatImage(item.posterUrl, 698, 350)) ||
                    '',
            }));

        return slideData;
    } catch (error) {
        console.error(error);
    }

    return data;
};

const isInArray = (value, keywords) => {
    const arr = keywords && keywords.split(' ');

    for (let i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
            return true;
        }
    }

    return false;
};
// 过滤视频
const filterVideo = item => {
    const disable = ['习近平'];
    let _item = {};

    disable.forEach(el => {
        if (Number(String(item.title).indexOf(el)) > -1 || (item.tags && isInArray(el, item.tags))) {
            return;
        }
        _item = item;
    });

    return _item;
};

module.exports = {
    jsonParse: data => {
        try {
            return JSON.parse(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHeadlinePicData: data => {
        try {
            return data.slice(0, 10).map(item => ({
                base62Id: item.base62Id,
                url: item.url,
                title: item.title,
                children: handleChildrenData(item.children),
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleMeetingData: data => {
        try {
            return data.slice(0, 7).map(item => ({
                banner: item.thumbnail !== '' ? formatImage(item.thumbnail, 300, 169) : '',
                title: item.title,
                url: item.url,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleBannerPicData: data => {
        try {
            return data.slice(0, 5).map(
                (item, index) =>
                    item.type === 'web' && item.title.includes('http')
                        ? {
                              url: item.url,
                              title: item.title,
                              type: item.type,
                          }
                        : {
                              thumbnail: item.thumbnail ? formatImage(item.thumbnail, 570, 356) : item.thumbnail,
                              url: item.url,
                              title: item.title,
                          },
            );
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleDayStockData: data => {
        try {
            return data.slice(0, 1).map(item => ({
                thumbnail: item.thumbnail ? formatImage(item.thumbnail, 300, 166) : item.thumbnail,
                url: item.url,
                title: item.title,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleFinanceListData: data => {
        try {
            return data.slice(0, 6).map(item => ({
                url: item.url,
                title: item.title,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleFinanceVideoData: data => {
        try {
            return data.slice(0, 5).map(item => ({
                thumbnail: item.thumbnail ? formatImage(item.thumbnail, 98, 55) : item.thumbnail,
                url: item.url,
                title: item.title,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    getTop3: data => {
        try {
            // 需求变更，多加一条
            // return data.slice(0, 3);
            return data.slice(0, 4);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleIndexSlideData: data => {
        try {
            return data.slice(0, 1).map(item => ({
                thumbnail: item.thumbnail && formatImage(item.thumbnail, 360, 220),
                url: item.url,
                title: item.title,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleRecommendFLiveData: data => {
        try {
            return data.slice(0, 2).map(item => ({
                thumbnail: item.thumbnail && formatImage(item.thumbnail, 157, 71),
                url: formatUrl(item.url),
                title: item.title,
                summary: item.summary,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleRecommendImageData: data => {
        try {
            return data.map(item => ({
                thumbnail: item.thumbnail ? formatImage(item.thumbnail, 50, 58) : item.thumbnail,
                url: item.url,
                title: item.title,
                summary: item.summary,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleNewsSiderContentData: options => data => {
        try {
            const { index } = options;

            /* eslint-disable no-confusing-arrow */
            return data.map(
                (item, ind) =>
                    ind === index
                        ? {
                              thumbnail: item.thumbnail ? formatImage(item.thumbnail, 75, 60) : item.thumbnail,
                              url: item.url,
                              title: item.title,
                              summary: item.summary,
                              children: handleChildrenData(item.children),
                              pcNewsMark: item.pcNewsMark,
                          }
                        : {
                              url: item.url,
                              title: item.title,
                              children: handleChildrenData(item.children),
                              pcNewsMark: item.pcNewsMark,
                          },
            );
            /* eslint-enable no-confusing-arrow */
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleNewsSiderContentListData: data => {
        try {
            /* eslint-disable no-confusing-arrow */
            return data.map(item => ({
                thumbnail: item.thumbnail ? formatImage(item.thumbnail, 75, 42) : item.thumbnail,
                url: item.url,
                title: item.title,
                children: handleChildrenData(item.children),
                pcNewsMark: item.pcNewsMark,
            }));
            /* eslint-enable no-confusing-arrow */
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleNewsTitleAdData: data => {
        try {
            return data.map(item => ({
                url: item.url,
                title: item.title,
                children: handleChildrenData(item.children),
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleNewsContentData: data => {
        try {
            return data.map(item => ({
                url: item.url,
                title: item.title,
                children: handleChildrenData(item.children),
                pcNewsMark: item.pcNewsMark,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleNewsContentDataByLen: options => data => {
        try {
            const { len } = options;

            return data.slice(0, len).map(item => ({
                url: item.url,
                title: item.title,
                children: handleChildrenData(item.children),
                pcNewsMark: item.pcNewsMark,
            }));

            return result;
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleNewsData: options => data => {
        try {
            const { isHidden } = options;

            return data.slice(0, isHidden === '1' ? 24 : 23).map(item => ({
                url: item.url,
                title: item.title,
                children: handleChildrenData(item.children),
                pcNewsMark: item.pcNewsMark,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleNewsVideoContentData: options => data => {
        try {
            const { index } = options;

            /* eslint-disable no-confusing-arrow */
            return data.map(
                (item, ind) =>
                    ind === index
                        ? {
                              thumbnail: item.thumbnail ? formatImage(item.thumbnail, 120, 92) : item.thumbnail,
                              url: item.url,
                              title: item.title,
                              children: handleChildrenData(item.children),
                              pcNewsMark: item.pcNewsMark,
                          }
                        : {
                              url: item.url,
                              title: item.title,
                              children: handleChildrenData(item.children),
                              pcNewsMark: item.pcNewsMark,
                          },
            );
            /* eslint-enable no-confusing-arrow */
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleVideoContentData: options => data => {
        try {
            const { index, len } = options;
            let result = [];

            if (len) {
                result = data.slice(0, len);
            } else {
                result = data;
            }

            /* eslint-disable no-confusing-arrow */
            return result.map(
                (item, ind) =>
                    ind === index
                        ? {
                              thumbnail: item.thumbnail ? formatImage(item.thumbnail, 120, 118) : item.thumbnail,
                              url: item.url,
                              title: item.title,
                              children: handleChildrenData(item.children),
                              pcNewsMark: item.pcNewsMark,
                          }
                        : {
                              url: item.url,
                              title: item.title,
                              children: handleChildrenData(item.children),
                              pcNewsMark: item.pcNewsMark,
                          },
            );
            /* eslint-enable no-confusing-arrow */
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleVideoContentData1: data => {
        try {
            return data.map(item => ({
                isVideo: true,
                url: item.url,
                title: item.title,
                children: handleChildrenData(item.children),
                pcNewsMark: item.pcNewsMark,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleNewsBoxData: data => {
        try {
            return data.map(item => ({
                isVideo: item.type === 'phvideo' || item.type === 'video',
                thumbnail: item.thumbnail ? formatImage(item.thumbnail, 170, 118) : item.thumbnail,
                url: item.url,
                title: item.title,
                children: handleChildrenData(item.children),
                pcNewsMark: item.pcNewsMark,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeNavInfo: data => {
        try {
            return data.map(item => ({
                title: item.title || '',
                url: item.url || '',
                redHot: item.active || '',
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeRedHeader: data => {
        try {
            return {
                image: data.image || '',
                isBegin: data.isBegin,
                startTime: data.startTime,
                endTime: data.endTime,
            };
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeSlideInfo: data => {
        try {
            return data.map((item, index) => ({
                id: item.commentUrl || item.id || index,
                type: item.type || '',
                title: item.title || '',
                src:
                    (item.thumbnails &&
                        item.thumbnails.image &&
                        item.thumbnails.image[0].url &&
                        formatImage(item.thumbnails.image[0].url, 698, 350)) ||
                    '',
                url: item.url || '',
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeSlideNovelInfo: data => {
        try {
            return data.map(item => ({
                title: item.title || '',
                src:
                    (item.thumbnails &&
                        item.thumbnails.image &&
                        item.thumbnails.image[0].url &&
                        formatImage(item.thumbnails.image[0].url, 698, 350)) ||
                    '',
                url: item.url || '',
                articleTag: '翻阅小说',
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeStickInfo: data => {
        try {
            return data.map((item, index) => ({
                id: item.id || index,
                type: item.type || 'article',
                title: item.title,
                url: item.url,
                stick: 2,
                wwwUrl: item.wwwUrl || '',
                source: item.source || '',
                base62Id: item.base62Id || item.commentUrl,
                commentUrl: item.commentUrl || '',
                children:
                    item.children &&
                    item.children.map((childitem, childindex) => ({
                        id: childitem.id || childindex,
                        type: childitem.type || 'article',
                        title: childitem.title,
                        url: childitem.url,
                        stick: 2,
                        source: childitem.source || '',
                        base62Id: childitem.base62Id || childitem.commentUrl,
                        commentUrl: childitem.commentUrl || '',
                        children: childitem.children,
                    })),
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleNewEraInfo: data => {
        try {
            return data.map((item, index) => ({
                id: item.id || index,
                type: item.type || 'article',
                title: item.title,
                url: item.url,
                wwwUrl: item.wwwUrl || '',
                source: item.source || '',
                base62Id: item.base62Id || item.commentUrl,
                commentUrl: item.commentUrl || '',
                stick: 2,
                noStickText: 1,
                hasBottomLine: 1
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeHeadLinesMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeHeadLinesInfo: data => {
        try {
            return homeFeedFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeHeadLinesNovelFeedInfo: data => {
        try {
            return homeFeedFormatData(data.slice(0, 12), '小说');
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeNewSubInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeNewSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeNewsNovelFeedInfo: data => {
        try {
            return homeFeedFormatData(data.slice(0, 12), '小说');
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeFinanceMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeFinanceSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeDynamicSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomefinanceRecommendFeedInfo: data => {
        try {
            return homeFeedFormatData(data.slice(0, 12));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeEntMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeEntSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeEntRecommendFeedInfo: data => {
        try {
            return homeFeedFormatData(data.slice(0, 12));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeEntNovelRecommendFeedInfo: data => {
        try {
            return homeFeedFormatData(data.slice(0, 12), '小说');
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeMilMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeMilSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeMilFeedInfo: data => {
        try {
            return homeFeedFormatData(data.slice(0, 12));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeSportMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeSportSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeSportFeedInfo: data => {
        try {
            return homeFeedFormatData(data.slice(0, 12));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeVideoMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeVideoSlideInfo: data => {
        try {
            return homeModuleSlideFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeAutoMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeAutoSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeAutoFourPicInfo: data => {
        try {
            return data.map(item => ({
                title: item.title || '',
                url: item.url || '',
                image: item.src || '',
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeHouseMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeHistoryMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeHistorySlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeHistoryRecommendFeedInfo: data => {
        try {
            return homeFeedFormatData(data.slice(0, 12));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeNovelMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeNovelFeedInfo: data => {
        try {
            if (data && data.slice(0, 15)) {
                return homeFeedFormatData(data.slice(0, 15));
            }
        } catch (error) {
            console.error(error);
        }
    },
    handleHomeNovelSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeTechMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeTechSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeSocietyMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeSocietySlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeFashionMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeFashionSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeHealthMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeHealthSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomehealthRecommendFeedInfo: data => {
        try {
            return homeFeedFormatData(data.slice(0, 12));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeBuddhismMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeBuddhismSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeBuddhismFeedInfo: data => {
        try {
            return homeFeedFormatData(data.slice(0, 12));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomePictureMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomePictureSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeFmMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeFmSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeFmRecommendFeedInfo: data => {
        try {
            return homeFeedFormatData(data.slice(0, 12));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeWutongMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeWutongSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeWutongRecommendFeedInfo: data => {
        try {
            return homeFeedFormatData(data.slice(0, 12));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeGameMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeGameSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeGameFeedInfo: data => {
        try {
            if (data && data.slice(0, 12)) {
                return homeFeedFormatData(data.slice(0, 12));
            }
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeTravelMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeTravelSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data).slice(0, 3);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeTravelFeedInfo: data => {
        try {
            if (data && data.slice(0, 12)) {
                return homeFeedFormatData(data.slice(0, 12));
            }
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeFoodMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeFoodSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeVipMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeVipSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeWineMdInfo: data => {
        try {
            return homeModuleTitleFormatData(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeWineSlideInfo: data => {
        try {
            return homeModuleBannerFormatData(data)[0];
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeFooterInfo: data => {
        try {
            return data.map(item => ({
                title: item.title || '',
                url: item.url || '',
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHomeAppRecommendInfo: data => {
        try {
            return data.map(item => ({
                title: item.title || '',
                image: item.src || '',
                androidurl: item.androidurl || '',
                iosurl: item.iosurl || '',
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleFFHNewsBoxData: data => {
        try {
            return data.map(item => ({
                isVideo: item.type === 'phvideo' || item.type === 'video',
                thumbnail: item.thumbnail ? formatImage(item.thumbnail, 170, 118) : item.thumbnail,
                url:
                    item.type === 'article' || item.type === 'slide'
                        ? `https://feng.ifeng.com/c/${item.base62Id}`
                        : item.url,
                title: item.title,
                children: handleChildrenData(item.children),
                pcNewsMark: item.pcNewsMark,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleStudioSlidePicData: data => {
        try {
            return data.slice(0, 5).map(item => ({
                thumbnail: item.thumbnail ? formatImage(item.thumbnail, 300, 225) : item.thumbnail,
                url: item.url,
                title: item.title,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleBrandsRec: data => {
        try {
            // data.sort((a, b) => {
            //     return Date.parse(b.newsTime) - Date.parse(a.newsTime);
            // });

            return data.map(item => ({
                title: item.title || '',
                guid: item.guid || '',
                url: item.url || '',
                thumbnail: item.thumbnail && formatImage(item.thumbnail, 198, 112),
                source: item.source,
                newsTime: item.newsTime,
            }));
        } catch (e) {
            console.error(e);
        }
    },
    handleVideoSlideData: data => {
        try {
            return data.slice(0, 5).map(item => ({
                thumbnail: item.thumbnail && formatImage(item.thumbnail, 720, 416),
                url: item.url,
                title: item.title,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleVideoRecommend: data => {
        try {
            return data.map(item => ({
                thumbnail: item.thumbnail && formatImage(item.thumbnail, 720, 416),
                url: item.url,
                title: item.title,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleBrandsLeague: data => {
        try {
            return data.map(item => ({
                thumbnail: item.thumbnail && formatImage(item.thumbnail, 160, 36),
                url: item.url,
                title: item.title,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    handleHotTopicsSpring: data => {
        try {
            return data.map(item => ({
                thumbnail: item.thumbnail && formatImage(item.thumbnail, 300, 168),
                url: item.url,
                title: item.title,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    /**
     * @param {Array} data 待处理的数据
     * @param {Number} length 截取的长度
     * @param {Number} type 待处理的数据来源 0 tv 1 v
     */
    handleTvVideoStream: (data, length = 25, type) => {
        const toLink = [
            '//tv.ifeng.com/c/',
            '//v.ifeng.com/c/'
        ];

        try {
            return data.slice(0, length).map(item => ({
                posterUrl: item.posterUrl,
                title: item.title,
                columnName: item.columnName || item.wemediaEAccountName,
                newsTime: item.newsTime,
                duration: item.duration,
                guid: item.guid,
                base62Id: item.base62Id,
                url: item.base62Id ? `${toLink[type]}${item.base62Id}` : item.url,
                type: item.type,
                thumbnails: item.thumbnails,
                commentUrl: item.commentUrl
            }));
        } catch (e) {
            console.error(e);
        }
    },
};
